import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  addStudentAcadYear: null,
  status: 'idle',
  error: null,
};

const addStudentAcadYearSlice = createSlice({
  name: 'addStudentAcadYear',
  initialState,
  reducers: {
    setStudentAcadYear(state, action) {
      state.addStudentAcadYear = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    clearStudentAcadYear(state) {
      state.addStudentAcadYear = null;
      state.status = 'idle';
      state.error = null;
    },
    setError(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
  },
});

export const { setStudentAcadYear, clearStudentAcadYear, setError } = addStudentAcadYearSlice.actions;

export default addStudentAcadYearSlice.reducer;